import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import DashboardLayout from "./DashboardLayout";

const EditInvoiceFinance = () => {
    const [invoices, setInvoices] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [editId, setEditId] = useState(null);
    const [errors, setErrors] = useState({});
    const recordsPerPage = 10;

    const [form, setForm] = useState({
        invoiceType: "",
        supplierType: "",
        poType: "",
        poNumber: "",
        poDate: "",
        agreementId: "",
        invoiceDate: "",
        invoiceNumber: "",
        invoiceFile: null,
        existingInvoiceFile: "",
        deliveryChallanNumber: "",
        comments: "",
        existingAgreementFile: "",
        existingTimesheetFile: "",
    });
    const [agreementList, setAgreementList] = useState([]);
    const [files, setFiles] = useState({
        invoiceCopy: null,
        poAgreement: null,
        timesheet: null,
        poAdmin: null,
        prAdmin: null,
    });
    const [showFilePreview, setShowFilePreview] = useState(false);
    const [previewFileUrl, setPreviewFileUrl] = useState("");
    const [previewFileTitle, setPreviewFileTitle] = useState("");
    const [previewFileName, setPreviewFileName] = useState("");

    const [lineItems, setLineItems] = useState([emptyLineItem()]);

    function emptyLineItem() {
        return {
            description: "",
            orderedQty: "",
            suppliedQty: "",
            invoiceValue: "",
            cgst: "",
            sgst: "",
            igst: "",
            totalValue: "",
            remarks: "",
        };
    }

    useEffect(() => {
        loadInvoices();
    }, []);

    const loadInvoices = async () => {
        try {
            const res = await axios.get("/api/invoices/finance-edit-list");
            setInvoices(res.data);
        } catch (err) {
            console.error("Error loading invoices:", err);
        }
    };


    const handleLineItemChange = (index, field, value) => {
        const updated = [...lineItems];
        updated[index][field] = value;

        const invoiceValue = parseFloat(updated[index].invoiceValue) || 0;
        const cgst = parseFloat(updated[index].cgst) || 0;
        const sgst = parseFloat(updated[index].sgst) || 0;
        const igst = parseFloat(updated[index].igst) || 0;
        updated[index].totalValue = (invoiceValue + (invoiceValue * (cgst + sgst + igst)) / 100).toFixed(2);

        setLineItems(updated);
    };

    const addLineItem = () => setLineItems([...lineItems, emptyLineItem()]);
    const removeLineItem = (index) => setLineItems(lineItems.filter((_, i) => i !== index));
    const openInvoiceFilePreview = async (type, title, fileName) => {
        if (!fileName) return;
        try {
            const res = await axios.get(
                `/api/UpdateData/invoice-file/${editId}/${type}?mode=view`,
                { responseType: "blob" }
            );
            const blobUrl = URL.createObjectURL(res.data);
            setPreviewFileUrl(blobUrl);
            setPreviewFileTitle(title);
            setPreviewFileName(fileName);
            setShowFilePreview(true);
        } catch (err) {
            console.error("Error loading file:", err);
            alert("Could not load the file.");
        }
    };

    const handleSave = async () => {

        try {
            // 1. Save invoice header
            const updateForm = new FormData();
            updateForm.append("invoiceType", form.invoiceType);
            updateForm.append("InvoiceNo", form.invoiceNumber);
            updateForm.append("InvoiceDate", form.invoiceDate);
            updateForm.append("supplierType", form.supplierType);
            updateForm.append("pono", form.poType === "PO" ? form.poNumber : "");
            updateForm.append(
                "POType",
                form.poType === "PO"
                    ? 1
                    : form.poType === "Agreement"
                        ? 2
                        : form.poType === "Approval"
                            ? 3
                            : ""
            );
            updateForm.append(
                "AgreementId",
                form.poType === "Agreement" ? form.agreementId || "" : ""
            );
            updateForm.append("PO_Date", form.poType === "PO" ? form.poDate : "");
            if (form.invoiceFile) {
                updateForm.append("invoiceFile", form.invoiceFile);
            }

            await axios.put(`/api/invoices/vendorinvoicedetails/${editId}`, updateForm, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            // 2. Save GRN line items
            const grnPayload = lineItems.map((item) => ({
                Description: item.description,
                Qty: item.orderedQty ? Number(item.orderedQty) : 0,
                RcvQty: item.suppliedQty ? Number(item.suppliedQty) : 0,
                InvoiceValue: item.invoiceValue ? Number(item.invoiceValue) : 0,
                CGST: item.cgst ? Number(item.cgst) : 0,
                SGST: item.sgst ? Number(item.sgst) : 0,
                IGST: item.igst ? Number(item.igst) : 0,
                TotalValue: item.totalValue ? Number(item.totalValue) : 0,
                remark: item.remarks,
            }));

            await axios.put(`/api/invoices/grnitems/update?grnId=${editId}`, grnPayload);
            // 1b. Upload PO/Agreement, Timesheet, PO(Admin), PR(Admin) files if any new ones selected
            const hasNewFiles = files.poAgreement || files.timesheet || files.poAdmin || files.prAdmin;
            if (hasNewFiles) {
                const reviewForm = new FormData();
                reviewForm.append("Id", Number(editId));
                reviewForm.append("Dept_ID", "1");
                reviewForm.append("ApprovalStatus", "");
                if (files.poAgreement) reviewForm.append("POFile", files.poAgreement);
                if (files.timesheet) reviewForm.append("TimesheetFile", files.timesheet);

                await axios.post("/api/invoices/vendorinvoicedetails-review", reviewForm, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            }

            alert("Invoice updated successfully");
            resetForm();
            loadInvoices();
        } catch (err) {
            console.error(err);
            alert("Error updating invoice");
        }
    };

    const resetForm = () => {
        setForm({
            invoiceType: "",
            supplierType: "",
            poType: "",
            poNumber: "",
            agreementId: "",
            invoiceDate: "",
            invoiceNumber: "",
            invoiceFile: null,
            existingInvoiceFile: "",
            deliveryChallanNumber: "",
            comments: "",
            existingAgreementFile: "",
            existingTimesheetFile: "",
        });
        setFiles({
            invoiceCopy: null,
            poAgreement: null,
            timesheet: null,
            poAdmin: null,
            prAdmin: null,
        });
        setLineItems([emptyLineItem()]);
        setEditId(null);
    };
    const handleEdit = async (item) => {
        try {
            const { data } = await axios.get(`/api/invoices/details/${item.id}`);
            const { data: grnItems } = await axios.get(`/api/invoices/grnitems/${item.id}`);

            setEditId(item.id);
            setForm({
                invoiceType: data.invoiceType || "",
                supplierType: data.invoiceSupplierType != null ? String(data.invoiceSupplierType) : "",
                poType: data.poType || (data.pono === "Agreement" ? "Agreement" : (data.pono ? "PO" : "")),
                poNumber: data.pono || "",
                poDate: data.po_Date ? data.po_Date.split("T")[0] : "",
                agreementId: data.agreementId || "",
                invoiceDate: data.invoiceDate ? data.invoiceDate.split("T")[0] : "",
                invoiceNumber: data.invoiceNo || "",
                invoiceFile: null,
                existingInvoiceFile: data.fileName || "",
                deliveryChallanNumber: data.deliveryChallanNumber || "",
                comments: "",
                existingAgreementFile: data.fileNameAgreement || "",
                existingTimesheetFile: data.fileNameTimeSheet || "",
            });

            setFiles({
                invoiceCopy: null,
                poAgreement: null,
                timesheet: null,
                poAdmin: null,
                prAdmin: null,
            });
            const uid = data.userId ?? data.USERID ?? data.userID;
            if (uid) {
                const { data: agreements } = await axios.get(`/api/vendoragreement/byuser/${uid}`);
                setAgreementList(agreements || []);
            } else {
                setAgreementList([]);
            }

            setLineItems(
                Array.isArray(grnItems) && grnItems.length > 0
                    ? grnItems.map((g) => ({
                        description: g.description || g.Description || "",
                        orderedQty: "",
                        suppliedQty: "",
                        invoiceValue: g.invoiceValue || g.InvoiceValue || "",
                        cgst: g.cgst || g.CGST || "",
                        sgst: g.sgst || g.SGST || "",
                        igst: g.igst || g.IGST || "",
                        totalValue: g.totalValue || g.TotalValue || "",
                        remarks: g.remark || g.Remark || "",
                    }))
                    : [emptyLineItem()]
            );
            window.scrollTo(0, 0);
        } catch (err) {
            console.error("Error loading invoice details:", err);
            alert("Failed to load invoice details.");
        }
    };

    const handleCancel = () => resetForm();

    const indexOfLast = currentPage * recordsPerPage;
    const indexOfFirst = indexOfLast - recordsPerPage;
    const currentRecords = invoices.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(invoices.length / recordsPerPage);

    return (
        <DashboardLayout>
            <div className="container-fluid py-3">

                {/* Edit Form */}
                <div className="card invoice-card mb-4">
                    <div className="edit-header d-flex justify-content-between align-items-center">
                        <div>
                            <h5 className="mb-1">
                                {editId ? "Edit Invoice" : "Invoice Editor"}
                            </h5>

                            <small>
                                {editId
                                    ? `Editing invoice #${form.invoiceNumber || editId}`
                                    : "Select an invoice from the list below"}
                            </small>
                        </div>

                        {editId && (
                            <span
                                style={{
                                    background: "#e7f1ff",
                                    color: "#0d6efd",
                                    border: "1px solid #b6d4fe",
                                    borderRadius: "20px",
                                    padding: "7px 15px",
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                EDIT MODE
                            </span>

                        )}
                    </div>

                    {editId && (
                        <div className="card-body p-4">
                            <div className="row g-3 mb-4">
                                <div className="col-md-2">
                                    <label className="invoice-form-label">Invoice Type <span className="text-danger">*</span></label>
                                    <select
                                        className={`form-select ${errors.invoiceType ? "is-invalid" : ""}`}
                                        value={form.invoiceType}
                                        onChange={(e) => setForm({ ...form, invoiceType: e.target.value })}
                                    >
                                        <option value="">Select</option>
                                        <option value="Tax Invoice">Tax Invoice</option>
                                        <option value="Debit Note">Debit Note</option>
                                    </select>
                                    {errors.invoiceType && <div className="invalid-feedback">{errors.invoiceType}</div>}
                                </div>

                                <div className="col-md-2">
                                    <label className="invoice-form-label">Supplier Type <span className="text-danger">*</span></label>
                                    <select
                                        className={`form-select ${errors.supplierType ? "is-invalid" : ""}`}
                                        value={form.supplierType}
                                        onChange={(e) => setForm({ ...form, supplierType: e.target.value })}
                                    >
                                        <option value="">Select</option>
                                        <option value="1">Supply of Material</option>
                                        <option value="2">Supply of Service</option>
                                        <option value="3">Both</option>
                                    </select>
                                    {errors.supplierType && <div className="invalid-feedback">{errors.supplierType}</div>}
                                </div>

                                <div className="col-md-2">
                                    <label className="invoice-form-label">PO / Agreement</label>
                                    <select
                                        className="form-select"
                                        value={form.poType}
                                        onChange={(e) => setForm({ ...form, poType: e.target.value })}
                                    >
                                        <option value="">Select</option>
                                        <option value="PO">PO</option>
                                        <option value="Agreement">Agreement</option>
                                        <option value="Approval">Approval</option>
                                    </select>
                                </div>

                                {form.poType === "PO" && (
                                    <>
                                        <div className="col-md-2">
                                            <label className="invoice-form-label">PO Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="PO Number"
                                                value={form.poNumber}
                                                onChange={(e) => setForm({ ...form, poNumber: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="invoice-form-label">PO Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={form.poDate}
                                                onChange={(e) => setForm({ ...form, poDate: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="invoice-form-label">PO Copy</label>
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                onChange={(e) => setFiles({ ...files, poAgreement: e.target.files[0] })}
                                            />
                                            {form.existingAgreementFile ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-link btn-sm p-0 mt-1"
                                                    onClick={() =>
                                                        openInvoiceFilePreview("agreement", "PO Copy Preview", form.existingAgreementFile)
                                                    }
                                                >
                                                    View current: {form.existingAgreementFile}
                                                </button>
                                            ) : (
                                                <div className="small text-muted mt-1">No file uploaded</div>
                                            )}
                                        </div>
                                    </>
                                )}

                                {form.poType === "Agreement" && (
                                    <div className="col-md-2">
                                        <label className="invoice-form-label">Agreement Reference</label>
                                        <select
                                            className="form-select"
                                            value={form.agreementId}
                                            onChange={(e) => setForm({ ...form, agreementId: e.target.value })}
                                        >
                                            <option value="">Select agreement</option>
                                            {agreementList.map((a) => (
                                                <option key={a.agreementId} value={a.agreementId}>{a.agreementDate}</option>
                                            ))}
                                        </select>
                                        {form.existingAgreementFile && (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm mt-2"
                                                style={{ whiteSpace: "normal", textAlign: "left", lineHeight: "1.3" }}
                                                onClick={() =>
                                                    openInvoiceFilePreview("agreement", "Agreement Preview", form.existingAgreementFile)
                                                }
                                            >
                                                View current: {form.existingAgreementFile}
                                            </button>
                                        )}
                                    </div>
                                )}

                                <div className="col-md-2">
                                    <label className="invoice-form-label">Invoice Date <span className="text-danger">*</span></label>
                                    <input
                                        type="date"
                                        className={`form-control ${errors.invoiceDate ? "is-invalid" : ""}`}
                                        value={form.invoiceDate}
                                        onChange={(e) => setForm({ ...form, invoiceDate: e.target.value })}
                                    />
                                    {errors.invoiceDate && <div className="invalid-feedback">{errors.invoiceDate}</div>}
                                </div>

                                <div className="col-md-2">
                                    <label className="invoice-form-label">Invoice Number <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.invoiceNumber ? "is-invalid" : ""}`}
                                        value={form.invoiceNumber}
                                        onChange={(e) => setForm({ ...form, invoiceNumber: e.target.value })}
                                    />
                                    {errors.invoiceNumber && <div className="invalid-feedback">{errors.invoiceNumber}</div>}
                                </div>

                                <div className="col-md-2">
                                    <label className="invoice-form-label">Invoice Copy</label>
                                    <input
                                        type="file"
                                        className="form-control form-control-sm"
                                        onChange={(e) => setForm({ ...form, invoiceFile: e.target.files[0] })}
                                    />
                                    {form.existingInvoiceFile ? (
                                        <button
                                            type="button"
                                            className="btn btn-link btn-sm p-0 mt-1"
                                            onClick={() =>
                                                openInvoiceFilePreview("invoice", "Invoice Copy Preview", form.existingInvoiceFile)
                                            }
                                        >
                                            View current: {form.existingInvoiceFile}
                                        </button>
                                    ) : (
                                        <div className="small text-muted mt-1">No file uploaded</div>
                                    )}
                                </div>
                            </div>

                            <h6 className="text-uppercase text-muted small mb-3" style={{ letterSpacing: "0.5px" }}>
                                Goods / Services Details
                            </h6>

                            <div className="table-responsive rounded border">
                                <table className="table table-sm align-middle mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ minWidth: 160 }}>Description</th>
                                            <th style={{ minWidth: 110 }}>Invoice Value</th>
                                            <th style={{ minWidth: 80 }}>CGST %</th>
                                            <th style={{ minWidth: 80 }}>SGST %</th>
                                            <th style={{ minWidth: 80 }}>IGST %</th>
                                            <th style={{ minWidth: 110 }}>Total Value</th>
                                            <th style={{ minWidth: 140 }}>Remarks</th>
                                            <th style={{ minWidth: 90 }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lineItems.map((item, index) => (
                                            <tr key={index}>
                                                <td><input className="form-control form-control-sm" value={item.description} onChange={(e) => handleLineItemChange(index, "description", e.target.value)} /></td>
                                                <td><input type="number" className="form-control form-control-sm" value={item.invoiceValue} onChange={(e) => handleLineItemChange(index, "invoiceValue", e.target.value)} /></td>
                                                <td><input type="number" className="form-control form-control-sm" value={item.cgst} onChange={(e) => handleLineItemChange(index, "cgst", e.target.value)} /></td>
                                                <td><input type="number" className="form-control form-control-sm" value={item.sgst} onChange={(e) => handleLineItemChange(index, "sgst", e.target.value)} /></td>
                                                <td><input type="number" className="form-control form-control-sm" value={item.igst} onChange={(e) => handleLineItemChange(index, "igst", e.target.value)} /></td>
                                                <td><input className="form-control form-control-sm bg-light" value={item.totalValue} readOnly /></td>
                                                <td><input className="form-control form-control-sm" value={item.remarks} onChange={(e) => handleLineItemChange(index, "remarks", e.target.value)} /></td>
                                                <td className="text-center">
                                                    <button
                                                        type="button"
                                                        onClick={() => removeLineItem(index)}
                                                        title="Delete row"
                                                        style={{
                                                            width: "32px",
                                                            height: "32px",
                                                            borderRadius: "6px",
                                                            border: "1px solid #dc3545",
                                                            background: "#fff",
                                                            color: "#dc3545",
                                                            fontSize: "18px",
                                                            fontWeight: "500",
                                                            cursor: "pointer",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        ×
                                                    </button>

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginTop: "20px",
                                    paddingTop: "15px",
                                    borderTop: "1px solid #e9ecef",
                                }}
                            >
                                {/* Add Row */}
                                <button
                                    type="button"
                                    onClick={addLineItem}
                                    style={{
                                        background: "#fff",
                                        color: "#0d6efd",
                                        border: "1px solid #0d6efd",
                                        borderRadius: "7px",
                                        padding: "8px 16px",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                        transition: "all 0.2s ease",
                                    }}
                                >
                                    ＋ Add Row
                                </button>

                                {/* Right side buttons */}
                                <div style={{ display: "flex", gap: "10px" }}>

                                    {/* Cancel */}
                                    <button
                                        type="button"
                                        onClick={handleCancel}
                                        style={{
                                            background: "#fff",
                                            color: "#495057",
                                            border: "1px solid #adb5bd",
                                            borderRadius: "7px",
                                            padding: "8px 20px",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Cancel
                                    </button>

                                    {/* Save */}
                                    <button
                                        type="button"
                                        onClick={handleSave}
                                        style={{
                                            background: "linear-gradient(135deg, #0d6efd, #0b5ed7)",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "7px",
                                            padding: "8px 22px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                            boxShadow: "0 3px 8px rgba(13, 110, 253, 0.25)",
                                        }}
                                    >
                                        ✓ Save Changes
                                    </button>

                                </div>
                            </div>

                        </div>
                    )}
                </div>

                {/* Invoice List */}
                <div
                    className="card border-0"
                    style={{
                        borderRadius: "12px",
                        overflow: "hidden",
                        boxShadow: "0 4px 18px rgba(15, 23, 42, 0.08)",
                    }}
                >
                    {/* Header */}
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{
                            padding: "18px 22px",
                            background: "#ffffff",
                            borderBottom: "1px solid #e5e7eb",
                        }}
                    >
                        <div>
                            <h5
                                className="mb-1"
                                style={{
                                    color: "#1e293b",
                                    fontWeight: "700",
                                    fontSize: "18px",
                                }}
                            >
                                Invoice List
                            </h5>

                            <small style={{ color: "#64748b" }}>
                                Manage and edit submitted invoices
                            </small>
                        </div>

                        <div
                            style={{
                                background: "#eff6ff",
                                color: "#2563eb",
                                border: "1px solid #dbeafe",
                                borderRadius: "20px",
                                padding: "7px 14px",
                                fontSize: "12px",
                                fontWeight: "600",
                            }}
                        >
                            {invoices.length} Invoices
                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                        <table
                            className="table mb-0 align-middle"
                            style={{
                                minWidth: "850px",
                            }}
                        >
                            <thead
                                style={{
                                    background: "#f8fafc",
                                    borderBottom: "1px solid #e2e8f0",
                                }}
                            >
                                <tr>
                                    <th
                                        style={{
                                            width: "60px",
                                            padding: "14px 16px",
                                            color: "#64748b",
                                            fontSize: "12px",
                                            fontWeight: "700",
                                        }}
                                    >
                                        #
                                    </th>

                                    <th
                                        style={{
                                            padding: "14px 16px",
                                            color: "#64748b",
                                            fontSize: "12px",
                                            fontWeight: "700",
                                        }}
                                    >
                                        INVOICE NO.
                                    </th>

                                    <th
                                        style={{
                                            padding: "14px 16px",
                                            color: "#64748b",
                                            fontSize: "12px",
                                            fontWeight: "700",
                                        }}
                                    >
                                        VENDOR
                                    </th>

                                    

                                    <th
                                        style={{
                                            padding: "14px 16px",
                                            color: "#64748b",
                                            fontSize: "12px",
                                            fontWeight: "700",
                                        }}
                                    >
                                        TOTAL VALUE
                                    </th>

                                   
                                    <th
                                        className="text-center"
                                        style={{
                                            width: "90px",
                                            padding: "14px 16px",
                                            color: "#64748b",
                                            fontSize: "12px",
                                            fontWeight: "700",
                                        }}
                                    >
                                        ACTION
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {currentRecords.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan="7"
                                            className="text-center"
                                            style={{
                                                padding: "50px 20px",
                                                color: "#94a3b8",
                                            }}
                                        >
                                            <div style={{ fontSize: "32px", marginBottom: "8px" }}>
                                                📄
                                            </div>

                                            <div
                                                style={{
                                                    fontWeight: "600",
                                                    color: "#64748b",
                                                }}
                                            >
                                                No invoices found
                                            </div>

                                            <small>
                                                There are no invoices available to edit.
                                            </small>
                                        </td>
                                    </tr>
                                ) : (
                                    currentRecords.map((item, index) => (
                                        <tr
                                            key={item.id}
                                            style={{
                                                borderBottom: "1px solid #f1f5f9",
                                            }}
                                        >
                                            {/* Number */}
                                            <td
                                                style={{
                                                    padding: "15px 16px",
                                                    color: "#94a3b8",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                {indexOfFirst + index + 1}
                                            </td>

                                            {/* Invoice Number */}
                                            <td style={{ padding: "15px 16px" }}>
                                                <strong
                                                    style={{
                                                        color: "#1e293b",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {item.invoiceNo}
                                                </strong>
                                            </td>

                                            {/* Vendor */}
                                            <td
                                                style={{
                                                    padding: "15px 16px",
                                                    color: "#475569",
                                                    fontSize: "13px",
                                                }}
                                            >
                                                {item.nameOfCompany}
                                            </td>

                                            
                                            {/* Total */}
                                            <td style={{ padding: "15px 16px" }}>
                                                <strong
                                                    style={{
                                                        color: "#0f172a",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    ₹ {Number(item.totalValue).toLocaleString("en-IN")}
                                                </strong>
                                            </td>

                                            {/* Action */}
                                            <td
                                                className="text-center"
                                                style={{ padding: "15px 16px" }}
                                            >
                                                <button
                                                    type="button"
                                                    title="Edit Invoice"
                                                    onClick={() => handleEdit(item)}
                                                    style={{
                                                        width: "36px",
                                                        height: "36px",
                                                        borderRadius: "8px",
                                                        border: "1px solid #bfdbfe",
                                                        background: "#eff6ff",
                                                        color: "#2563eb",
                                                        fontSize: "17px",
                                                        cursor: "pointer",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        transition: "all 0.2s ease",
                                                    }}
                                                >
                                                    ✎
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div
                            style={{
                                padding: "14px 20px",
                                borderTop: "1px solid #e5e7eb",
                                background: "#ffffff",
                            }}
                        >
                            <nav>
                                <ul className="pagination justify-content-end mb-0">
                                    <li
                                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                                            }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() =>
                                                currentPage > 1 &&
                                                setCurrentPage(currentPage - 1)
                                            }
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {[...Array(totalPages)].map((_, i) => (
                                        <li
                                            key={i}
                                            className={`page-item ${currentPage === i + 1 ? "active" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(i + 1)}
                                            >
                                                {i + 1}
                                            </button>
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                            }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() =>
                                                currentPage < totalPages &&
                                                setCurrentPage(currentPage + 1)
                                            }
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    )}
                </div>

            </div>

            <Modal isOpen={showFilePreview} toggle={() => setShowFilePreview(false)} size="lg" centered>
                <ModalHeader toggle={() => setShowFilePreview(false)}>{previewFileTitle}</ModalHeader>
                <ModalBody style={{ textAlign: "center", padding: 0 }}>
                    {previewFileName.toLowerCase().endsWith(".pdf") ? (
                        <iframe
                            src={previewFileUrl}
                            style={{ width: "100%", height: "80vh", border: "none", display: "block" }}
                            title="File Preview"
                        />
                    ) : (
                        <img
                            src={previewFileUrl}
                            style={{ maxWidth: "100%", maxHeight: "80vh", display: "block", margin: "0 auto" }}
                            alt="preview"
                        />
                    )}
                </ModalBody>
            </Modal>
        </DashboardLayout>
    );
};

export default EditInvoiceFinance;